<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <!-- <b-alert
      variant="success"
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert> -->
    <!-- <b-alert variant="warning" show>等待資訊</b-alert> -->
    <h2>嘉義縣農情調查(一期、二期、裡作)</h2>
    <div class="Info_Area">
      <b-container fluid>
          <b-row>
            <b-col cols="auto">
              <div class="py-2">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th scope="row">年度:</th>
                        <td>111</td>
                      </tr>
                      <tr>
                        <td>鄉鎮:</td>
                        <td>三民區</td>
                      </tr>
                      <tr>
                        <td>期別:</td>
                        <td>一期作</td>
                      </tr>
                      <tr>
                        <td>作物:</td>
                        <td>甘藷</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="pt-2 pb-4">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">區段</th>
                        <th scope="col">小區</th>
                        <th scope="col">種植面積</th>
                        <th scope="col">間作面積</th>
                        <th scope="col">前後期作面積</th>
                        <th scope="col">未達結實面積</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>鼎盛段</td>
                        <td>1</td>
                        <td>0.02</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>鼎盛段</td>
                        <td>1</td>
                        <td>0.02</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="text-center">
                  <b-button variant="primary" block href="#/DataBuildForFarmSearch">返回查詢</b-button>
                </div>
                
              </div>


            </b-col>
          </b-row>
      </b-container>
    </div>
  </b-container>
</template>
<script>
import ANIMALCODELIST from "@/data/ANIMAL_CODE_LIST.json";
//import datepicker from "@/components/Datepicker.vue";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    const minDate = new Date(today);
    minDate.setDate(date.getDate() - 7);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      perPage: 10,
      currentPage: 1,
      filterSearch: null,
      animalcodelist: ANIMALCODELIST,
      sortBy: "CM_DATE",
      selection: [],
      totalRows: 1,
      isBusy: false,
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      filtervalue: null,
      datamanagement: {
        ifshow: false,
        ifedit: false,
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "農情調查資料維護",
          active: true,
        },
      ],
      exceldata: {
        fields: {
          日期: "AM_DATE",
          種類: "TYPE",
          品項: "ITEM",
          規格: "AM_SPEC",
          "交易行情價(元/公斤)": "AM_TRADE",
          "最低成本(元/公斤)": "AM_PRICE_L",
          "最高成本(元/公斤)": "AM_PRICE_R",
          備註及說明: "AM_NOTES",
        },
        dataset: [],
        filename: "畜產品價格清單",
      },
      priceanalysis: {
        fields: [
          {
            key: "AM_DATE",
            label: "日期",
            visible: true,
          },
          {
            key: "AM_TYPE",
            label: "種類",
            visible: true,
          },
          {
            key: "AM_ITEM",
            label: "品項",
            visible: true,
          },
          {
            key: "AM_SPEC",
            label: "規格",
            visible: true,
          },
          {
            key: "AM_TRADE",
            label: "交易行情價(元/公斤)",
            visible: true,
          },
          {
            key: "AM_PRICE_L",
            label: "成本(元/公斤)",
            visible: true,
          },
          {
            key: "AM_PRICE_L_TW",
            label: "成本(元/台斤)",
            visible: true,
          },
          {
            key: "AM_NOTES",
            label: "備註",
            visible: true,
          },
          {
            key: "EDIT",
            label: "操作",
            visible: true,
          },
        ],
        fields_mobile: [
          {
            key: "AM_DATE",
            label: "日期",
            visible: true,
          },
          {
            key: "AM_ITEM",
            label: "品項",
            visible: true,
          },
          {
            key: "AM_SPEC",
            label: "規格",
            visible: true,
          },
          {
            key: "EDIT",
            label: "操作",
            visible: true,
          },
        ],
        items: [],
        allitems: [
          {
            AM_SORT: 1,
            AM_DATE: "2021-05-26",
            AM_TYPE: 0,
            AM_SPEC: "A001",
            AM_TRADE: 82.32,
            AM_PRICE_L: 54,
            AM_PRICE_R: 56,
            AM_NOTES: "備註1",
          },
          {
            AM_SORT: 2,
            AM_DATE: "2021-05-26",
            AM_TYPE: 0,
            AM_SPEC: "A002",
            AM_TRADE: 137,
            AM_PRICE_L: 103,
            AM_PRICE_R: 105,
            AM_NOTES: "備註2",
          },
          {
            AM_SORT: 3,
            AM_DATE: "2021-05-26",
            AM_TYPE: 1,
            AM_SPEC: "A004",
            AM_TRADE: 60,
            AM_PRICE_L: 44,
            AM_PRICE_R: 46,
            AM_NOTES: "備註3",
          },
        ],
        additem: {},
      },
      window: {
        width: 1024,
        height: 0,
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      animal: {
        options: [],
        value: { label: "全部", code: "全部" },
      },
      showmanage: {
        show: false,
        add: false,
        edit: false,
        delete: false,
        count: 0,
      },
      apiAnimalManagementList: (data) =>
        this.userRequest.post("/API/Default/AnimalManagementList", data),
    };
  },
  created() {
    this.checkLogin();
    // window.addEventListener('resize', this.handleResize);
    // this.handleResize();
    // this.init();
    // this.priceanalysis.items = JSON.parse(JSON.stringify(this.priceanalysis.allitems))
    // this.exceldata.dataset = JSON.parse(JSON.stringify(this.priceanalysis.allitems))
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    // this.checkLogin()
    // this.checkPermission()
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.showmanage.count = 0;
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000014",
        fun: this.checkByPJIDshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000015",
        fun: this.checkByPJIDadd,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000016",
        fun: this.checkByPJIDedit,
      });
    },
    // checkByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.$router.push({ path: "/" });
    //   } else {
    //     window.addEventListener("resize", this.handleResize);
    //     this.handleResize();
    //     this.init();
    //   }
    // },
    checkallpermission() {
      if (this.showmanage.show || this.showmanage.add || this.showmanage.edit) {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.init();
      } else {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      }
    },
    checkByPJIDshow(value) {
      this.showmanage.count++;
      if (value) this.showmanage.show = true;
    },
    checkByPJIDadd(value) {
      this.showmanage.count++;
      if (value) this.showmanage.add = true;
    },
    checkByPJIDedit(value) {
      this.showmanage.count++;
      if (value) this.showmanage.edit = true;
    },
    checkByPJIDdelete(value) {
      this.showmanage.count++;
      if (value) this.showmanage.delete = true;
    },
    AnimalManagementList(data) {
      this.apiAnimalManagementList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.priceanalysis.items = [];
            this.exceldata.dataset = [];
            let reginallist = JSON.parse(json.Data);
            let dataItems = reginallist.filter((x) => x.AM_ISDEL == 0);
            if (dataItems.length != 0) {
              dataItems.sort((a, b) => {
                if (a.AM_DATE == b.AM_DATE) {
                  return (a.AM_SORT > b.AM_SORT) - (a.AM_SORT < b.AM_SORT);
                }
                return (a.AM_DATE < b.AM_DATE) - (a.AM_DATE > b.AM_DATE);
              });
              for (let i in dataItems) {
                let subitem = dataItems[i];
                if (subitem.AM_ISDEL != 1) {
                  let item4 = subitem.AM_ITEM;
                  let datetime1 = subitem.AM_DATE.split("T")[0].split("-");
                  datetime1[0] = parseInt(datetime1[0]) - 1911;
                  subitem.AM_DATE = datetime1.join("-");
                  subitem.ITEM = this.getname(item4);
                  subitem.TYPE = subitem.AM_TYPE == 0 ? "家畜" : "家禽";
                  this.exceldata.dataset.push(subitem);
                }
              }
              this.priceanalysis.items = dataItems;
              // this.exceldata.dataset = dataItems
              this.totalRows = dataItems.length;
              if (this.timepicker.minvalue == this.timepicker.maxvalue)
                this.perPage = this.priceanalysis.items.length;
              else this.perPage = 10;
            }
            this.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    //  checkLogin() {
    //     let TokenID = sessionStorage.getItem("TokenID");
    //     if(TokenID){
    //         this.checkPermission()
    //     }
    //     else
    //     {
    //         alert("無權限檢視此頁面，請登入帳號")
    //         this.$router.push({ path: '/login' })
    //     }
    // },
    init() {
      this.createoptions();
      this.getAnimalManagementList();
      this.settotalRows();
      // this.priceanalysis.items = [...this.priceanalysis.allitems]
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    
    changetimeformat(time) {
      // let tt = time.split('T')[0]
      // tt[0] = parseInt(tt[0]) - 1911
      // return tt.join('-')
      return time.split("T")[0];
    },
    getname(data) {
      let index = this.animal.options.findIndex((y) => y.code == data);
      return index != -1 ? this.animal.options[index].label : data;
    },
    uploadFile(e) {
      const file = e.target.files[0];
      console.log(file);
      let formdata = new FormData();
      formdata.append("Files", file);
      this.userRequest
        .post("API/Default/AnimalExcelUpload", formdata)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            console.log(jsonData);
            alert("上傳成功");
            this.$route.go();
          } else {
            console.warn("上傳失敗");
          }
        });
    },
    createoptions() {
      let list2 = [{ label: "全部", code: "全部" }];
      let index = this.animalcodelist.findIndex((x) => x.AM_TYPE == 2);
      let list3 = this.animalcodelist[index].AM_LIST;
      for (let i in list3) {
        let item1 = list3[i];
        let obj = {
          label: item1.AM_SPEC,
          code: item1.AM_CODE,
        };
        list2.push(obj);
      }
      this.animal.options = list2;
    },
    getAnimalManagementList() {
      this.isBusy = true;
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      let obj = {
        start_date: localmintime.join("-"),
        end_date: localmaxtime.join("-"),
      };
      this.FunctionToken(this.AnimalManagementList, obj);
    },
    filteritems() {
      if (this.animal.value == undefined || this.animal.value == null) {
        alert("請選擇搜尋條件");
      } else {
        let localmintime = this.timepicker.minvalue.split("-");
        localmintime[0] = parseInt(localmintime[0]) + 1911;
        let localmaxtime = this.timepicker.maxvalue.split("-");
        localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

        let obj = {
          start_date: localmintime.join("-"),
          end_date: localmaxtime.join("-"),
        };
        if (this.animal.value.code != "全部") {
          obj["AM_SPEC"] = this.animal.value.code;
        }
        this.isBusy = true;
        this.FunctionToken(this.AnimalManagementList, obj);
      }
    },
    // async checkPermission() {
    //   let accountdata = { PJ_ID: "PJ000000000014", fun: this.checkshowByPJID };
    //   this.FunctionToken(this.Authority, accountdata);
    //   let databuilddata = {
    //     PJ_ID: "PJ000000000015",
    //     fun: this.checkeditdataByPJID,
    //   };
    //   this.FunctionToken(this.Authority, databuilddata);
    // },
    // checkshowByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.datamanagement.ifshow = false;
    //     this.$router.push({ path: "/" });
    //   } else {
    //     this.datamanagement.ifshow = true;
    //     this.FunctionToken(this.getTradeWarningCrop, {});
    //     this.settotalRows();
    //   }
    // },
    // checkeditdataByPJID(value) {
    //   if (!value) {
    //     this.datamanagement.ifedit = false;
    //   } else {
    //     this.datamanagement.ifedit = true;
    //   }
    // },
    checksave(item) {
      if (this.IsNull(item.TC_LIMIT)) {
        this.priceanalysis.additem = item;
        this.$bvModal.show("savemodal");
      }
    },
    changePage(item) {
      let value = item.item.AM_DATE.split("T")[0];
      // value[0] = value[0] - 1911
      this.$router.push({
        name: "DataBuildAddForAnimal",
        params: { id: value },
      });
    },
    hideModal() {
      this.priceanalysis.additem = {};
      this.$bvModal.hide("savemodal");
    },
    getNow: function() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "" +
        (today.getMonth() + 1) +
        "" +
        today.getDate();
      const time =
        today.getHours() + "" + today.getMinutes() + "" + today.getSeconds();
      const dateTime = date + "" + time;
      return "-" + dateTime;
    },
    addcount() {
      for (let i in this.priceanalysis.items) {
        this.priceanalysis.items[i]["Count"] = parseInt(i) + 1;
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
    settotalRows() {
      this.totalRows = this.priceanalysis.items.length;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
  },
  computed: {
    visibleFields() {
      return this.priceanalysis.fields.filter((field) => field.visible);
    },
  },
  watch: {
    "priceanalysis.items"() {
      this.settotalRows();
    },
    "showmanage.count"(val) {
      if (val == 3) {
        this.checkallpermission();
      }
    },
  },
  components: {
    //datepicker,
  },
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}
.hideheadr {
  background-color: red !important;
}
.picker {
  width: 200px;
}
</style>
